import { useCallback, useSyncExternalStore } from 'react'

/**
 * Whether a CSS media query, such as `(min-width: 1200px)`, matches now; it updates as the
 * window changes. For where the markup itself differs by width, not just its classes.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query)
      list.addEventListener('change', onChange)
      return () => list.removeEventListener('change', onChange)
    },
    [query],
  )
  return useSyncExternalStore(subscribe, () => window.matchMedia(query).matches)
}
